import { GrowthBook } from "@growthbook/growthbook";

// Erstelle die GrowthBook-Instanz
const gb = new GrowthBook({
  apiHost: "https://cdn.growthbook.io",
  clientKey: process.env.MIX_VUE_APP_GROWTHBOOK_KEY,
});

// Asynchrone Initialisierung
async function initializeGrowthBook() {
  await gb.init();
}

// Exportiere die Instanz und die Initialisierungsfunktion
export { gb, initializeGrowthBook };